import React from 'react'
import { bool, func, string } from 'prop-types'

import { Modal, ModalBody } from 'components/qstrap'
import Relazsizes from 'relazsizes'

import Button from 'components/atoms/Button'
import MarkdownContent from 'components/atoms/MarkdownContent'
import Typography from 'components/atoms/Typography'

import config from 'config'

const { assets_url: assetsUrl } = config
const predictionAssetsPath = `${assetsUrl}/assets/img/paperplane/result/prediction`

const CategoryModal = ({
  isOpen,
  onModalClose,
  title,
  summary,
  explanation,
  illustration,
}) => (
  <Modal
    autoFocus={false}
    isOpen={isOpen}
    fade={false}
    toggle={onModalClose}
    className="category-modal__dialog"
  >
    <ModalBody>
      <div className="category-modal__wrapper">
        <Relazsizes
          dataSrc={`${predictionAssetsPath}/${illustration}@2x.png`}
          alt="category-modal"
          className="category-modal__img"
        />
        <div className="category-modal__text">
          <Typography component="h3" variant="title" className="variant-title-sm m-b-md">
            {title}
          </Typography>
          <MarkdownContent content={summary} />
          <Typography component="p" variant="subheading">{explanation}</Typography>
        </div>
        <Button tag="a" onClick={onModalClose} variant="default" className="category-modal__btn">
          Mengerti
        </Button>
      </div>
    </ModalBody>
    <style jsx global>
      {`
        .modal-backdrop {
          background-color: #1a344f;
        }
        .category-modal {
          &__dialog {
            height: 100%;
            max-width: 972px;
            margin: 215px auto;
            
            .modal-content {
              border: none !important;
              box-shadow: none !important;
              padding: 40px;
            }
            .modal-body {
              padding: 0;
              height: 100%;
            }
          }
          &__wrapper {
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
          }
          :global(&__img) {
            width: 360px;
            position: absolute;
            top: -50%;
          }
          &__text {
            margin-left: 400px;
            color: #1a344f;
            :global(p) {
              line-height: 1.5 !important;
            }
          }
          :global(&__btn) {
            font-weight: bold;
            padding: 16px 32px;
            float: right;
            margin: 24px 0 0 auto;
          }

          @media screen and (max-width: 767px) {
            &__dialog {
              height: 100%;
              margin: 80px 24px;
            }
            :global(&__img) {
              width: 232px;
              position: initial;
              margin-bottom: 24px;
            }
            &__text {
              margin: 0;
              flex-grow: 2;
              :global(h3) {
                font-size: 24px !important;
              }
              :global(p) {
                font-size: 14px !important;
              }
            }
            :global(&__btn) {
              width: 100%;
              padding: 12px;
            }
          }
        }
      `}
    </style>
  </Modal>
)

CategoryModal.propTypes = {
  isOpen: bool,
  onModalClose: func,
  title: string,
  summary: string,
  explanation: string,
  illustration: string,
}

export default CategoryModal
